import { formatUrl } from 'lib/formatUrl'
import Link from 'next/link'

type Props = {
  text: string
  href: string
  hasChildPages?: boolean
}

const SitemapLink = ({ text, href, hasChildPages }: Props) => {
  const formattedUrl = formatUrl(href)
  return (
    <Link href={formattedUrl} passHref>
      <a className="flex cursor-pointer items-center space-x-2 hover:underline">
        <div className={`h-2 w-2 flex-shrink-0 ${hasChildPages ? 'bg-tella-blue-300' : 'bg-tella-blue-100'}`}></div>
        <span className="text-lg">{text}</span>
      </a>
    </Link>
  )
}

export default SitemapLink
